import { Spin } from 'antd';
import React from 'react';
import './index.scss';

export default function Loader() {
  return (
    <div className="antd-loader">
      <Spin size="large" />
    </div>
  );
}
